
export const LOCATIONS_PAGE_BG_BR = 'bg-brandRefresh-background-primary';

export const LOCATIONS_PAGE_BG_LEGACY =
  'bg-white dark:bg-gradient-from-t dark:bg-gradient-to-b dark:from-darkBlack dark:to-dark';

/** Full-width parent shell — fills viewport gutters without changing inner layout */
export const LOCATIONS_PAGE_SHELL_BR = 'w-full bg-brandRefresh-background-primary';

/** Figma Content Container = 1200px @ x=120 on 1440 artboard → 120px side gutters */
export const LOCATIONS_PAGE_WRAPPER_LAYOUT_BR =
  'w-full max-w-[1200px] mx-auto px-4 md:px-6 lg:px-0';

export const LOCATIONS_LIST_TITLE_BR = 'uppercase';

export const LOCATIONS_LIST_TITLE_LEGACY =
  'text-dark dark:text-white font-congenialBlack font-black text-4xl leading-9 tracking-tighter';

export const LOCATIONS_STORE_DETAIL_TITLE_LEGACY =
  'text-dark dark:text-white font-congenialBlack font-black text-4xl leading-9 tracking-tighter';

export const LOCATIONS_SEARCH_FIELD_GROUP_BR = 'flex flex-col w-full';

export const LOCATIONS_SEARCH_ROW_BR = 'flex w-full';

export const LOCATIONS_SEARCH_INPUT_CONTAINER_BR = 'min-w-0 flex-1';

export const LOCATIONS_SEARCH_LOCATION_BTN_BR = 'shrink-0';

export const LOCATIONS_SEARCH_INPUT_CONTAINER_LEGACY =
  'border-[1px] border-lightDry rounded-[48px] px-4';

export const LOCATIONS_SEARCH_INPUT_BR =
  'flex-1 min-w-0 border-none outline-none bg-transparent';

export const LOCATIONS_SEARCH_INPUT_LEGACY =
  'text-dark dark:text-white bg-transparent inputDarkModeOverride';

export const LOCATIONS_SEARCH_ICON_BR = 'h-5 w-5 shrink-0';

export const LOCATIONS_SEARCH_CLEAR_BTN_BR =
  'flex shrink-0 items-center justify-center bg-transparent border-none p-0 cursor-pointer h-6 w-6';

export const LOCATIONS_SEARCH_CLEAR_ICON_BR = 'h-5 w-5';

export const LOCATIONS_NO_STORES_HEADING_BR =
  'text-brandRefresh-foreground-onPrimary font-brandRefreshFellix text-brandRefresh-bodyLarge text-center';

export const LOCATIONS_NO_STORES_HEADING_LEGACY = 'text-dark dark:text-white';

export const LOCATIONS_MOBILE_PANEL_BG_BR = 'bg-brandRefresh-background-primary';

export const LOCATIONS_MOBILE_PANEL_BG_LEGACY = 'bg-white dark:bg-dark';

export const getLocationsPageShellClass = (br, showLocation) =>
  br && !showLocation ? LOCATIONS_PAGE_SHELL_BR : '';

export const getLocationsPageWrapperClass = (styles, br, { showLocation }) => {
  if (!br || showLocation) {
    return `${styles.pageWrapper} max-w-screen-desktop mx-auto ${LOCATIONS_PAGE_BG_LEGACY}`;
  }
  return `${styles.pageWrapper} ${LOCATIONS_PAGE_WRAPPER_LAYOUT_BR} ${LOCATIONS_PAGE_BG_BR}`;
};

export const getLocationsListTitleClass = (br, showLocation) => {
  if (showLocation) {
    return LOCATIONS_STORE_DETAIL_TITLE_LEGACY;
  }
  return br ? LOCATIONS_LIST_TITLE_BR : LOCATIONS_LIST_TITLE_LEGACY;
};

export const getLocationsInputWrapperClass = (styles, br) =>
  br ? LOCATIONS_SEARCH_ROW_BR : styles.locationsInputWrapper;

export const getLocationsSearchInputContainerClass = (styles, br) => {
  if (br) {
    return LOCATIONS_SEARCH_INPUT_CONTAINER_BR;
  }
  return `${styles.locationInputContainer} ${LOCATIONS_SEARCH_INPUT_CONTAINER_LEGACY}`;
};

export const getLocationsSearchInputClass = (br) =>
  br ? LOCATIONS_SEARCH_INPUT_BR : LOCATIONS_SEARCH_INPUT_LEGACY;

export const getLocationsNoStoresHeadingClass = (br) =>
  br ? LOCATIONS_NO_STORES_HEADING_BR : LOCATIONS_NO_STORES_HEADING_LEGACY;

export const getLocationsMobilePanelClass = (styles, br) =>
  `${styles.locationsContainerMobile} ${br ? LOCATIONS_MOBILE_PANEL_BG_BR : LOCATIONS_MOBILE_PANEL_BG_LEGACY}`;

export const getLocationsListClass = (styles) => styles.locationsList;
